"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentContainer = exports.CloseCross = exports.Title = exports.ModalWindow = exports.BackgroundArea = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
exports.BackgroundArea = styled_components_1.default.div `
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 100;
`;
exports.ModalWindow = styled_components_1.default.div `
  padding: 3.5rem 2rem;
  width: fit-content;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: ${theme_1.WHITE};
  box-shadow: ${theme_1.ElevationShadow3};
  max-height: 90vh;
  overflow-y: auto;
`;
exports.Title = styled_components_1.default.h2 `
  margin: 0;
  font: bold 2.5rem/3rem "SwegonBrown";
`;
exports.CloseCross = styled_components_1.default.div `
  position: absolute;
  right: 24px;
  top: 24px;
  display: flex;
  cursor: pointer;
  margin-left: auto;
`;
exports.ContentContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;
//# sourceMappingURL=Modal.styles.js.map